import axios, { AxiosError } from "axios";
import { useState } from "react";
import ApiBack from "../../../utils/domains/ApiBack";
import { Form } from "react-bootstrap";
import logo from "../../../assets/images/Rocky/LOGOROCKY.png";
import { ToastContainer } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";

interface LoginResponse {
    success: boolean;
    message?: string;
    token: string;
}

export default function LoginAux() {
    const [inProcess, setProcess] = useState<boolean>(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    type formHtml = React.FocusEvent<HTMLFormElement>;
    const myNavigate = useNavigate();


    const handleLogin = async () => {
        try {
            await axios.post(
                ApiBack.URL + ApiBack.LOGIN_AUX,
                { password }
            );

            window.location.href = "/privado";
        } catch (err) {

        }
    };

    const proccesForm = async (fh: formHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);

            const formCurrent = fh.currentTarget;
            formCurrent.classList.add("was-validated");

            if (!formCurrent.checkValidity()) {
                fh.stopPropagation();
                setProcess(false);
                return;
            }

            const result = await axios.post<LoginResponse>(
                ApiBack.URL + ApiBack.LOGIN_AUX,
                { password }
            );


            if (result.data.success) {
                MessageToastify("success", "Acceso concedido", 2000);
                localStorage.setItem("accessUptc", result.data.token);
                myNavigate("/main-uptc");
            }

        } catch (error) {

            const err = error as AxiosError<{ error: string }>;
            console.log(err.response?.data.error)
            const message =
                err.response?.data?.error || "Error al iniciar sesión";
            console.log(message);

            MessageToastify("error", message, 3000);

        } finally {
            setProcess(false);
        }
    };
    

    return (
        <>
            <div
                className="min-h-screen bg-gradient-soft flex items-center justify-center p-4"
                style={{
                    background:
                        "linear-gradient($color-background-gradient-start, $color-background-gradient-end)",
                }}
            >
                <div
                    className="login-wrapper relative p-4 rounded "
                    style={{
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                        width: "450px",

                        boxShadow: "0px 2px 9px rgba(0, 0, 0, 0.5)",
                    }}
                >

                    <div className="d-flex justify-content-center ">

                        <div className="">
                            <img
                                src={logo}
                                alt="Logo Rocky"
                                style={{
                                    width: "150px",
                                    height: "auto",
                                    marginLeft: "10px",
                                }}
                            />

                        </div>

                    </div>

                    <h1
                        style={{
                            fontSize: "50px", // Tamaño grande
                            fontWeight: "bold", // Negrilla
                            color: "#d9931175", // Color específico
                            fontFamily: "Arial, sans-serif", // Fuente diferente
                            textAlign: "center", // Centrar el texto // Margen superior del 50%
                            textShadow: "1px 1px 2px black", // Sombra negra alrededor del texto
                        }}
                    >
                        Rocky
                    </h1>

                    <Form
                        noValidate
                        validated={inProcess}
                        onSubmit={proccesForm}
                        autoComplete="off"
                    >

                        <Form.Group controlId="password" className="mt-3">
                            <Form.Label className="text-black">Contraseña:</Form.Label>
                            <div className="relative">
                                <Form.Control
                                    required
                                    name="password"
                                    className="form-control pr-10" // agrega espacio a la derecha
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Introduce tu contraseña"
                                    value={password}
                                    onChange={(e) => (setPassword(e.target.value))}
                                    autoComplete="off"
                                    style={{
                                        color: "$color-primary-text",
                                        borderRadius: "20px",
                                        border: "1px solid black",
                                        textAlign: "center",
                                        outline: "none",
                                    }}
                                />

                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-10 top-1/4 -translate-y text-black-500 hover:text-black transition-colors "
                                >
                                    {showPassword ? (
                                        <EyeOff className="w-7 h-7" />
                                    ) : (
                                        <Eye className="w-7 h-7" />
                                    )}
                                </button>

                                <Form.Control.Feedback type="invalid">
                                    La contraseña es requerida para ingresar.
                                </Form.Control.Feedback>
                            </div>
                        </Form.Group>



                        <button
                            className="btn btn-block login-btn mt-4 w-100"
                            type="submit"
                            style={{
                                backgroundColor: "$color-button-background",
                                color: "$color-primary-text",
                                borderRadius: "20px", // También puedes redondear el botón
                                boxShadow: "0px 4px 6px #d9931175!important", // Sombra para el botón
                            }}
                            disabled={inProcess}
                        >
                            {inProcess ? "Ingresando..." : "Ingresar"}
                        </button>
                    </Form>
                </div>
                <ToastContainer />
            </div>
        </>
    );
}